module.exports = __webpack_public_path__ + "img/operationCapacity9.345fb29b.png";